import React, { useState, useEffect } from 'react';
import { FiSettings, FiLock, FiUnlock, FiCheck, FiX } from 'react-icons/fi';
import api from '../../utils/api';
import toast from 'react-hot-toast';

const VendorPermissions = () => {
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchVendors();
  }, []);

  const fetchVendors = async () => {
    try {
      const response = await api.get('/vendor-owner/vendors/permissions');
      setVendors(response.data.data);
    } catch (error) {
      toast.error('Failed to fetch vendors');
    } finally {
      setLoading(false);
    }
  };

  const togglePermission = async (vendorId, currentPermission) => {
    try {
      await api.put(`/vendor-owner/vendors/${vendorId}/report-permissions`, {
        canViewReports: !currentPermission
      });
      toast.success('Permission updated successfully');
      fetchVendors();
    } catch (error) {
      toast.error('Failed to update permission');
    }
  };

  const getPermissionBadge = (vendor) => {
    if (!vendor.reportPermissions?.canViewReports) {
      return (
        <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800">
          <FiLock className="mr-1" size={10} />
          No Access
        </span>
      );
    }

    return (
      <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
        <FiUnlock className="mr-1" size={10} />
        Can View Reports
      </span>
    );
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Vendor Report Permissions</h1>
        <p className="text-gray-600 mt-1">Control which vendors can access reports</p>
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-gray-200">
        <div className="p-4 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-900">All Vendors</h2>
        </div>
        
        <div className="divide-y divide-gray-200">
          {vendors.map((vendor) => (
            <div key={vendor._id} className="p-4">
              <div className="flex items-center justify-between">
                <div className="flex-1">
                  <div className="flex items-center gap-3">
                    <div>
                      <h3 className="font-semibold text-gray-900">{vendor.personalDetails.name}</h3>
                      <p className="text-sm text-gray-600">{vendor.restaurantDetails.restaurantName}</p>
                    </div>
                    {getPermissionBadge(vendor)}
                  </div>
                </div>
                
                <button
                  onClick={() => togglePermission(vendor._id, vendor.reportPermissions?.canViewReports || false)}
                  className={`ml-4 inline-flex items-center px-3 py-2 border shadow-sm text-sm leading-4 font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 ${
                    vendor.reportPermissions?.canViewReports
                      ? 'border-red-300 text-red-700 bg-red-50 hover:bg-red-100 focus:ring-red-500'
                      : 'border-green-300 text-green-700 bg-green-50 hover:bg-green-100 focus:ring-green-500'
                  }`}
                >
                  {vendor.reportPermissions?.canViewReports ? (
                    <>
                      <FiX className="mr-1" size={14} />
                      Revoke Access
                    </>
                  ) : (
                    <>
                      <FiCheck className="mr-1" size={14} />
                      Grant Access
                    </>
                  )}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VendorPermissions;
